import { isLogtoEnabled } from '@savgroup-front-common/core/services/isLogtoEnabled';

const { hostname } = window.location;
const logtoClientId = '2l1o25a3z45k1mhawdojd';

const defaultAuthority = isLogtoEnabled()
  ? 'https://idp-demo.revers.io/oidc'
  : 'https://demo-login.revers.io';

const mapClientIdByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      'demo-app-cooperative-u.revers.io': '9gnhjsiu2ps9gqv6c72rd',
      'demo-app-maisonsdumonde.revers.io': 'nuadjf4ijwh8dtbzb3qkt',
      'demo-app-carrefour.revers.io': 'j3k51wysllzuelxcay9u7',
      'demo-app-auchan.revers.io': 'w07ca3ft9kewqnrer5eu1',
    }
  : {
      'demo-app.revers.io': 'demo-control.revers.io',
      'qualif-demo-app.revers.io': 'demo-control.revers.io',
      localhost: 'demo-control.revers.io',
    };

const mapAuthorityByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      localhost: defaultAuthority,
    }
  : {
      localhost: defaultAuthority,
    };

const mapDirectSigningByHostname: Record<string, string> = {
  'demo2-app.revers.io': 'sso:123456789',
  'demo-app-cooperative-u.revers.io': 'sso:q4btvt270dzr',
  'demo-app-salesforce.revers.io': 'sso:ztegopols8tp',
  'demo-app-maisonsdumonde.revers.io': 'sso:3zlns2z3kyat',
  'demo-app-carrefour.revers.io': 'sso:ri2rdzg3gf94',
  'demo-app-auchan.revers.io': 'sso:8ny7p66eojnl',
};

const mapPostLogoutRedirectUriByHostname: Record<string, string> = {
  'demo-app-maisonsdumonde.revers.io':
    'https://www.google.com/accounts/Logout/',
};

const AuthConfiguration = {
  authority: mapAuthorityByHostname[hostname] || defaultAuthority,
  clientId: isLogtoEnabled()
    ? mapClientIdByHostname[hostname] || logtoClientId
    : mapClientIdByHostname[hostname] || window.location.hostname,
  scope: isLogtoEnabled()
    ? 'openid email api offline_access profile'
    : 'openid email api',
  direct_sign_in: isLogtoEnabled()
    ? mapDirectSigningByHostname[hostname] || 'sso:123456789'
    : undefined,
  post_logout_redirect_uri: mapPostLogoutRedirectUriByHostname[hostname],
};

export default AuthConfiguration;
